import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import styles from './Loader.scss';

const Loader = ({ className, text }) => (
  <div className={cx(styles.loader, className)} data-testid="loader">
    <LoadingArrow showText={!!text} size="large" text={text} />
  </div>
);

Loader.propTypes = {
  className: PropTypes.string,
  text: PropTypes.node,
};

export default Loader;
